import * as React from "react";
import {Navigate} from "react-router-dom";

import {UNMATCHED_ROUTES, USER_ROLE} from "@constants";
import AppLayout from "Layout";
import UnmatchedNewProductsPage from "./NewProducts";


export const UnmatchedRoutes = {
	path: UNMATCHED_ROUTES.PATH,
	title: "Unmatched Products",
	icon: 'circle-question',
	iconWeight: 'light',
	element: <AppLayout />,
	description: '',
	access: USER_ROLE.ADMIN,
	children: [{ 
		element: <Navigate to={UNMATCHED_ROUTES.NEW_PRODUCTS_PATH} replace />, index: true 
	}, { 
		path: UNMATCHED_ROUTES.NEW_PRODUCTS_PATH, 
		element: <UnmatchedNewProductsPage />
	}]
}